var _path, _g, _g2, _g3, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 195,
    viewBox: "0 0 209 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13751_145942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 28,
    width: 145,
    height: 144
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.897 171.98C144.65 171.98 176.876 139.923 176.876 100.378C176.876 60.8329 144.65 28.7754 104.897 28.7754C65.1442 28.7754 32.918 60.8329 32.918 100.378C32.918 139.923 65.1442 171.98 104.897 171.98Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13751_145942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.897 171.98C144.65 171.98 176.876 139.923 176.876 100.378C176.876 60.8329 144.65 28.7754 104.897 28.7754C65.1442 28.7754 32.918 60.8329 32.918 100.378C32.918 139.923 65.1442 171.98 104.897 171.98Z",
    fill: "url(#paint0_linear_13751_145942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.897 171.98C144.65 171.98 176.876 139.923 176.876 100.378C176.876 60.8329 144.65 28.7754 104.897 28.7754C65.1442 28.7754 32.918 60.8329 32.918 100.378C32.918 139.923 65.1442 171.98 104.897 171.98Z",
    fill: "#E4E4E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13751_145942)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13751_145942)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105.275,
    cy: 100.376,
    r: 38.4392,
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.871 90.1161H114.314V89.5535C114.314 87.04 112.244 85 109.693 85H100.855C98.303 85 96.2339 87.04 96.2339 89.5535V90.1161H90.6755C88.1238 90.1161 86.0547 92.1551 86.0547 94.6696V111.198C86.0547 113.711 88.1238 115.751 90.6755 115.751H119.873C122.425 115.751 124.494 113.711 124.494 111.198V94.6696C124.492 92.1541 122.423 90.1161 119.871 90.1161ZM105.272 111.028C100.458 111.028 96.544 107.171 96.544 102.427C96.544 97.684 100.458 93.8257 105.272 93.8257C110.086 93.8257 114 97.683 114 102.427C114 107.171 110.085 111.028 105.272 111.028ZM109.893 102.427C109.893 104.935 107.819 106.98 105.272 106.98C102.726 106.98 100.651 104.935 100.651 102.427C100.651 99.9173 102.726 97.8733 105.272 97.8733C107.819 97.8733 109.893 99.9173 109.893 102.427Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter0_f_13751_145942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.54 71.7374C174.941 71.7374 187.427 59.2518 187.427 43.8501C187.427 28.4484 174.941 15.9629 159.54 15.9629C144.138 15.9629 131.652 28.4484 131.652 43.8501C131.652 59.2518 144.138 71.7374 159.54 71.7374Z",
    fill: "url(#paint1_linear_13751_145942)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M66.834 31.0371C70.9966 31.0371 74.3711 27.6626 74.3711 23.5C74.3711 19.3374 70.9966 15.9629 66.834 15.9629C62.6713 15.9629 59.2969 19.3374 59.2969 23.5C59.2969 27.6626 62.6713 31.0371 66.834 31.0371Z",
    fill: "url(#paint2_linear_13751_145942)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M165.827 163.484C158.482 161.516 150.932 165.875 148.964 173.22C146.996 180.565 151.355 188.116 158.7 190.084C166.045 192.052 173.596 187.693 175.564 180.348C177.532 173.002 173.173 165.452 165.827 163.484Z",
    fill: "url(#paint3_linear_13751_145942)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M38.7459 172.254C50.2898 172.254 59.648 162.913 59.648 151.39C59.648 139.868 50.2898 130.526 38.7459 130.526C27.202 130.526 17.8438 139.868 17.8438 151.39C17.8438 162.913 27.202 172.254 38.7459 172.254Z",
    fill: "url(#paint4_linear_13751_145942)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13751_145942",
    x: 124.115,
    y: 8.4258,
    width: 70.8476,
    height: 70.8486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.76855,
    result: "effect1_foregroundBlur_13751_145942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13751_145942",
    x1: 104.897,
    y1: 28.7754,
    x2: 104.897,
    y2: 171.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6EAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13751_145942",
    x1: 130.659,
    y1: 85.396,
    x2: 169.799,
    y2: 10.7376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13751_145942",
    x1: 59.0283,
    y1: 34.7286,
    x2: 69.6068,
    y2: 14.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13751_145942",
    x1: 181.347,
    y1: 160.661,
    x2: 153.139,
    y2: 191.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13751_145942",
    x1: 17.0989,
    y1: 182.473,
    x2: 46.3518,
    y2: 126.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13751_145942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8783,
    height: 76.8783,
    fill: "white",
    transform: "translate(66.8359 61.9365)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13751_145942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8783,
    height: 76.8783,
    fill: "white",
    transform: "translate(66.8359 61.9365)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePhoto);
export default __webpack_public_path__ + "static/media/change-photo.ef4687a6b35ab2e52c1fbad1de5938f8.svg";
export { ForwardRef as ReactComponent };